module.exports = "/_next/static/images/Hero@2x-09c5eebf8059b1ccdb435901de8aa07e.webp";